import React from "react";
import LandingByDate from "./LandingByDate";
import { useState } from "react";
import LandingByHours from "./LandingByHours";
import Footer from "./Footer";

const Landing = () => {

    const [page, setPage] = useState(LandingByHours);

    const handleOnChange = (event) => {
        if (event.target.id === "arrangeByHours"){
            setPage(<LandingByHours/>);
        } else {
            setPage(<LandingByDate />);
          }
    };

  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center my-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>

      <div className="d-flex justify-content-center gap-4">
        <div className="form-check">
          <input
            className="form-check-input custom-radio"
            type="radio"
            name="exampleRadios"
            id="arrangeByHours"
            value="option1"
            onChange={handleOnChange}
          />
          <label className="form-check-label" htmlFor="arrangeByHours">
            <h5>Arrange by Hours</h5>
          </label>
        </div>
        <div className="form-check">
          <input
            className="form-check-input custom-radio"
            type="radio"
            name="exampleRadios"
            id="arrangeByDate"
            value="option2"
            onChange={handleOnChange}
          />
          <label className="form-check-label" htmlFor="arrangeByDate">
            <h5>Arrange by Date</h5>
          </label>
        </div>
      </div>
      {page}
        <Footer/>
    </div>
  );
};

export default Landing;
